"use strict";

export const HoverNativeProperties = new Set(['hoverEffect']);
//# sourceMappingURL=HoverTypes.js.map